export default __webpack_public_path__ + "static/media/WM0490.34I-43521_-26002_0.feac9224.jpg";